"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUserCurrencyBalance = void 0;
var bn_js_1 = __importDefault(require("bn.js"));
var react_1 = require("react");
var web3_1 = __importDefault(require("web3"));
var pool_1 = require("../../pool");
var useUser_1 = require("../../shared/hooks/useUser");
var utils_1 = require("../../shared/utils");
var zeroBN = new bn_js_1.default("0");
function useUserCurrencyBalance() {
    var _a = (0, useUser_1.useUser)(), account = _a.account, funds = _a.funds;
    var fundToken = (0, pool_1.usePool)().pool.fundToken;
    var _b = (0, pool_1.usePoolCurrency)(), currency = _b[0], currencyInstance = _b[1];
    var isNetworkCurrency = !currency.address;
    var _c = (0, react_1.useState)(isNetworkCurrency ? funds : zeroBN), balance = _c[0], setBalance = _c[1];
    function update() {
        if (!isNetworkCurrency && account && currencyInstance) {
            (0, utils_1.call)(currencyInstance, "balanceOf", [account]).then(function (v) {
                return setBalance((0, utils_1.normalizeDecimals)(web3_1.default.utils.toBN(v), fundToken.decimals));
            });
        }
    }
    (0, react_1.useEffect)(function () {
        if (account && isNetworkCurrency) {
            setBalance(funds);
        }
    }, [account, funds, isNetworkCurrency]);
    (0, react_1.useEffect)(function () {
        update();
    }, [account, isNetworkCurrency, currencyInstance]);
    return [balance, update];
}
exports.useUserCurrencyBalance = useUserCurrencyBalance;
